import './NoAccess.css';

const NoAccess = () => {

  return (
    <>
       <div id="error-page">
         <div className="content">
            <h2 className="header" data-text="401">
               401
            </h2>
            <h4 data-text="Opps! Page not found">
               Oops! unauthorized
            </h4>
            <p>
               Sorry,You are not authorized to access this application, please request to be added on the right security group.
            </p>
            <div className="btns">
            </div>
         </div>
      </div>
    </>
  );
};
export default NoAccess;
